import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning_4a22a1538fa2861a825c189880b8f50e",
  "use": "warning_4a22a1538fa2861a825c189880b8f50e-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"warning_4a22a1538fa2861a825c189880b8f50e\">\n    <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M11 5h2a.5.5 0 0 1 .5.5v7.91a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5V5.5A.5.5 0 0 1 11 5zm0 11.03h2a.5.5 0 0 1 .5.5v1.97a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.97a.5.5 0 0 1 .5-.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol